import { maxBy } from 'lodash';
import mixpanel from 'mixpanel-browser';
import { useEffect } from 'react';

import { isStageDev } from '../../utils/common';
import useBraze from '../../utils/hook/external-library/useBraze';
import useChannelTalk from '../../utils/hook/external-library/useChannelTalk';
import useKakaoPixelPageView from '../../utils/hook/external-library/useKakaoPixelPageView';
import useReactPixel from '../../utils/hook/external-library/useReactPixel';
import { useMySubscriptionsQuery } from '../../utils/hook/react-query/useMySubscriptionsQuery';
import useMeQuery from '../../utils/hook/react-query/user/useMeQuery';
import { isAndroidWebview, isIosWebview } from '../../utils/react-native';

const LayoutExternalLibraries = () => {
  const { me } = useMeQuery();
  const { isLoading: isLoadingMySubscriptions, allActiveOrders } =
    useMySubscriptionsQuery();

  useReactPixel();

  useKakaoPixelPageView();

  useChannelTalk();

  useBraze();

  /**
   * Google Analytics 사용자 이메일 추적
   */
  useEffect(() => {
    if (me?.email) {
      window.gtag('set', 'user_data', {
        email: me.email,
      });
    }
  }, [me]);

  /**
   * Mixpanel 유저 초기화
   */
  useEffect(() => {
    try {
      mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_KEY!, {
        debug: isStageDev,
        track_pageview: true,
        persistence: 'localStorage',
      });
    } catch (error) {
      console.error('Mixpanel 초기화 실패:', error);
    }
  }, []);

  useEffect(() => {
    if (!me || isLoadingMySubscriptions) return;

    try {
      mixpanel.identify(me.id.toString());
      mixpanel.people.set({
        user_id: me.id.toString(),
        platform: (() => {
          if (isIosWebview()) return 'ios';
          if (isAndroidWebview()) return 'android';
          return 'web';
        })(),
        // 구독 회차 중 가장 큰 값
        subscription_count: maxBy(allActiveOrders, 'sequence')?.sequence ?? 0,
        membership: me.hasMembership,
        push_allowed: me.marketingPolicy,
        is_subscribed: me.isSubscribing,
      });
    } catch (error) {
      console.error('Mixpanel 유저 초기화 실패:', error);
    }
  }, [isLoadingMySubscriptions, allActiveOrders.length]);

  return null;
};

export default LayoutExternalLibraries;
